
import store from '../../store/store';
import { StoreState } from '../../store/store.interface';
import { isK12CustomStoreCart } from '../cart/shop-cart/store/shop-cart.selectors';
import { ClientTokenDetails, ClientTokenDetailsMagento, VaultedCard, VaultedCardsMagento } from '../checkout/shop-checkout.interface';

export const mapBraintreeMagentoResponse = (braintreeResponse: ClientTokenDetailsMagento): ClientTokenDetails => {
  return {
    token: braintreeResponse.token,
    threeDSecureEnabled: braintreeResponse.three_d_secure_enabled,
    environment: braintreeResponse.env,
    googleMerchantId: braintreeResponse.google_pay_merchant_id,
    paypalEnabled: braintreeResponse.paypal_enabled,
    vaultEnabled: braintreeResponse.vault_enabled,
    googlePayEnabled: braintreeResponse.google_pay,
    applePayEnabled: braintreeResponse.apple_pay,
    venmoEnabled: braintreeResponse.venmo_enabled,
    venmoProfileId: braintreeResponse?.venmo_profile_id,
    idealEnabled: braintreeResponse?.ideal,
    idealMerchantId: braintreeResponse?.ideal_merchant_id,
    vaultedCards: braintreeResponse.vaulted_cards?.map((vaultedCard: VaultedCardsMagento): VaultedCard => ({
      cardType: vaultedCard.card_type,
      bin: vaultedCard.bin,
      cardLast4: vaultedCard.card_last4,
      uniqueIdentifier: vaultedCard.unique_identifier,
      expiryYear: vaultedCard.expiry_year,
      expiryMonth: vaultedCard.expiry_month,
      cardHolderName: vaultedCard.card_holder_name,
      isExpired: vaultedCard.expired,
      isDefault: vaultedCard.default,
      billingAddress: {
        firstName: vaultedCard?.billing_address?.first_name!,
        lastName: vaultedCard?.billing_address?.last_name!,
        partySiteId: vaultedCard?.billing_address?.party_site_id,
        address1: vaultedCard?.billing_address?.address1! || '',
        address2: vaultedCard?.billing_address?.address2! || '',
        city: vaultedCard?.billing_address?.city! || '',
        state: vaultedCard?.billing_address?.state! || '',
        zipCode: vaultedCard?.billing_address?.zip_code! || '',
        county: vaultedCard?.billing_address?.county,
        country: vaultedCard?.billing_address?.country! || _defaultK12CustomStoreCountryCode(),
        rdiType: vaultedCard?.billing_address?.rdi_type,
        validated: vaultedCard?.billing_address?.validated,
        phoneNumber: vaultedCard?.billing_address?.phone_number! || '',
      },
    })),
  };
};

function _defaultK12CustomStoreCountryCode() {
  return isK12CustomStoreCart(store.getState() as StoreState) ? 'US' : '';
}